(() => {
  if (!document.getElementById('pelyko-brand-home-styles')) {
    const style = document.createElement('style');
    style.id = 'pelyko-brand-home-styles';
    style.textContent = `
      .pelyko-brand-home .pelyko-announcement{background:#18201b}.pelyko-brand-home .pelyko-announcement__inner{justify-content:space-between}.pelyko-brand-home .pelyko-announcement span:first-child{letter-spacing:.13em}.pelyko-brand-hero{background:radial-gradient(circle at 78% 32%,rgba(116,138,120,.22),transparent 30%),linear-gradient(135deg,#fbfaf6 0%,#edf1eb 100%)}.pelyko-brand-hero .pelyko-home-hero__grid{min-height:690px}.pelyko-brand-hero .pelyko-home-hero__title{max-width:720px;font-size:clamp(52px,6.7vw,92px)}.pelyko-brand-hero .pelyko-home-hero__lead{max-width:610px}.pelyko-brand-path{display:flex;align-items:center;gap:11px;margin-top:28px;padding-top:21px;border-top:1px solid rgba(17,21,18,.12);color:#344139;font-size:11px;font-weight:800;letter-spacing:.11em}.pelyko-brand-path i{color:#8b968e;font-style:normal}.pelyko-brand-stage .pelyko-stage-card--main{background:rgba(255,255,255,.66);box-shadow:0 42px 110px rgba(32,49,36,.15)}.pelyko-brand-stage:before{content:'PELYKO';position:absolute;left:4%;top:5%;font-size:clamp(66px,9vw,120px);font-weight:900;letter-spacing:-.07em;color:rgba(30,48,35,.055);z-index:0}.pelyko-brand-home #avis{padding-top:88px;padding-bottom:96px;background:#fff}.pelyko-brand-manifesto{background:#f4f1e9}.pelyko-manifesto-intro{display:grid;grid-template-columns:.55fr 1.45fr;gap:70px;align-items:start;margin-bottom:56px}.pelyko-manifesto-intro .pelyko-kicker{margin-top:10px}.pelyko-manifesto-title{margin:0;font-size:clamp(42px,5.8vw,76px);line-height:.98;letter-spacing:-.058em;max-width:900px}.pelyko-manifesto-intro p{grid-column:2;max-width:690px;margin:-26px 0 0;color:#626d65;font-size:18px;line-height:1.65}.pelyko-routine-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}.pelyko-routine-card{position:relative;min-height:620px;padding:26px;border-radius:30px;background:#fff;border:1px solid rgba(17,21,18,.08);display:flex;flex-direction:column;overflow:hidden;box-shadow:0 16px 46px rgba(28,42,31,.06)}.pelyko-routine-card--accent{background:#dfe9df}.pelyko-routine-card--dark{background:#17201a;color:#fff}.pelyko-routine-card__head{display:flex;align-items:center;justify-content:space-between;padding-bottom:18px;border-bottom:1px solid rgba(17,21,18,.12);font-size:11px;font-weight:850;letter-spacing:.14em}.pelyko-routine-card--dark .pelyko-routine-card__head{border-color:rgba(255,255,255,.15)}.pelyko-routine-card__head span{display:grid;place-items:center;width:34px;height:34px;border-radius:50%;background:#111512;color:#fff;letter-spacing:0}.pelyko-routine-card--dark .pelyko-routine-card__head span{background:#fff;color:#111512}.pelyko-routine-card__media{height:280px;margin:24px -4px 22px;display:grid;place-items:center;border-radius:22px;background:rgba(255,255,255,.72);overflow:hidden}.pelyko-routine-card__media img{width:92%;height:92%;object-fit:contain;filter:drop-shadow(0 20px 20px rgba(31,45,34,.12));transition:transform .3s ease}.pelyko-routine-card:hover .pelyko-routine-card__media img{transform:scale(1.04) rotate(-1deg)}.pelyko-routine-card h3{margin:0 0 10px;font-size:27px;line-height:1.03;letter-spacing:-.04em}.pelyko-routine-card p{margin:0;color:#68736b;font-size:14px;line-height:1.6}.pelyko-routine-card--dark p{color:rgba(255,255,255,.62)}.pelyko-routine-links{display:flex;gap:14px;flex-wrap:wrap;margin-top:auto;padding-top:24px}.pelyko-routine-links a{color:inherit;text-decoration:none;font-size:13px;font-weight:800;border-bottom:1px solid currentColor;padding-bottom:2px}.pelyko-why-section{background:#111512;color:#fff}.pelyko-why-section .pelyko-kicker{color:#bad0bd}.pelyko-why-head{max-width:920px}.pelyko-why-grid{display:grid;grid-template-columns:repeat(3,1fr);border-top:1px solid rgba(255,255,255,.14);border-bottom:1px solid rgba(255,255,255,.14)}.pelyko-why-card{min-height:330px;padding:32px 32px 36px;border-right:1px solid rgba(255,255,255,.14);display:flex;flex-direction:column}.pelyko-why-card:last-child{border-right:0}.pelyko-why-card>span{font-size:12px;color:#9db1a0;font-weight:800}.pelyko-why-card h3{margin:auto 0 13px;font-size:clamp(27px,3vw,39px);line-height:1;letter-spacing:-.045em;text-transform:uppercase}.pelyko-why-card p{margin:0;color:rgba(255,255,255,.62);line-height:1.6}.pelyko-essentials-head{max-width:880px}.pelyko-gesture-card .pelyko-problem-card__body{min-height:265px;display:flex;flex-direction:column}.pelyko-gesture-word{display:block;margin-bottom:20px;color:#506858;font-size:13px;font-weight:900;letter-spacing:.16em}.pelyko-gesture-card h3{font-size:24px}.pelyko-text-link{display:inline-flex;width:max-content;margin-top:auto;padding-top:24px;color:#111512;text-decoration:none;font-size:13px;font-weight:800;border-bottom:1px solid #111512}.pelyko-button--light{background:#fff;color:#111512;border-color:#fff}.pelyko-brand-final{background:linear-gradient(130deg,#dce7dc,#f4f0e8)}.pelyko-brand-final .pelyko-kicker{margin-bottom:16px}.pelyko-brand-final .pelyko-kicker:before{display:none}
      @media(max-width:1050px){.pelyko-manifesto-intro{grid-template-columns:1fr;gap:22px}.pelyko-manifesto-intro p{grid-column:1;margin:0}.pelyko-routine-grid{grid-template-columns:1fr}.pelyko-routine-card{min-height:520px}.pelyko-routine-card__media{height:300px}.pelyko-why-grid{grid-template-columns:1fr}.pelyko-why-card{min-height:240px;border-right:0;border-bottom:1px solid rgba(255,255,255,.14)}.pelyko-why-card:last-child{border-bottom:0}.pelyko-brand-path{justify-content:center}.pelyko-brand-home .pelyko-announcement__inner{justify-content:center}}
      @media(max-width:720px){.pelyko-brand-home .pelyko-announcement__inner span:nth-child(2){display:none}.pelyko-brand-hero .pelyko-home-hero__title{font-size:50px}.pelyko-brand-path{gap:7px;font-size:9px;letter-spacing:.07em;flex-wrap:wrap}.pelyko-manifesto-title{font-size:43px}.pelyko-routine-card{min-height:500px;padding:20px}.pelyko-routine-card__media{height:250px}.pelyko-why-card{padding:26px 22px;min-height:220px}.pelyko-gesture-card .pelyko-problem-card__body{min-height:230px}}
    `;
    document.head.appendChild(style);
  }
})();

(() => {
  document.body.classList.add('pelyko-active');

  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const drawer = document.querySelector('[data-pelyko-drawer]');
  const backdrop = document.querySelector('[data-pelyko-backdrop]');
  const drawerCount = document.querySelector('[data-pelyko-drawer-count]');
  const drawerTotal = document.querySelector('[data-pelyko-drawer-total]');

  const openDrawer = async () => {
    if (!drawer) return;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('[data-pelyko-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      if (drawerCount) drawerCount.textContent = `${cart.item_count} article${cart.item_count > 1 ? 's' : ''}`;
      if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
    } catch (_) {}
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  document.querySelectorAll('[data-pelyko-close-drawer]').forEach((el) => el.addEventListener('click', closeDrawer));
  backdrop?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('[data-pelyko-offer]').forEach((card) => {
    card.addEventListener('click', () => {
      const scope = card.closest('[data-pelyko-product-scope]');
      scope?.querySelectorAll('[data-pelyko-offer]').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
      const variantId = card.dataset.variantId;
      const variantPrice = card.dataset.variantPrice;
      scope?.querySelectorAll('input[name="id"]').forEach((input) => { input.value = variantId; });
      scope?.querySelectorAll('[data-pelyko-selected-price]').forEach((el) => { el.textContent = variantPrice; });
    });
  });

  const addVariant = async (form) => {
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Ajout en cours…'; }
    const data = new FormData(form);
    const response = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('add_failed');
    if (button) button.textContent = 'Ajouté ✓';
    setTimeout(() => { if (button) { button.disabled = false; button.textContent = original; } }, 900);
  };

  document.querySelectorAll('[data-pelyko-add-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      try { await addVariant(form); await openDrawer(); }
      catch (_) { window.location.href = '/cart'; }
    });
  });

  document.querySelectorAll('[data-pelyko-buy-now]').forEach((button) => {
    button.addEventListener('click', async () => {
      const form = button.closest('[data-pelyko-product-scope]')?.querySelector('[data-pelyko-add-form]');
      if (!form) return;
      button.disabled = true;
      button.textContent = 'Redirection…';
      try { await addVariant(form); window.location.href = '/checkout'; }
      catch (_) { window.location.href = '/cart'; }
    });
  });

  document.querySelectorAll('[data-pelyko-sticky-add]').forEach((button) => {
    button.addEventListener('click', () => document.querySelector('[data-pelyko-add-form]')?.requestSubmit());
  });

  document.querySelectorAll('[data-pelyko-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-pelyko-gallery]');
      const main = gallery?.querySelector('[data-pelyko-main-image]');
      if (!main) return;
      gallery.querySelectorAll('[data-pelyko-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      main.src = thumb.dataset.imageSrc;
      main.removeAttribute('srcset');
      main.alt = thumb.dataset.imageAlt || main.alt;
    });
  });

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-pelyko-tilt]').forEach((stage) => {
      stage.addEventListener('pointermove', (event) => {
        const rect = stage.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        stage.style.transform = `rotateX(${y * -7}deg) rotateY(${x * 8}deg) translateY(-3px)`;
      });
      stage.addEventListener('pointerleave', () => { stage.style.transform = ''; });
    });
  }

  /* PELYKO REVIEWS — preserve this visible review section. */
  const home = document.querySelector('.pelyko-home');
  if (home) {
    document.querySelector('.pelyko-hero-proof')?.remove();
    const reviewSection = document.querySelector('#avis');
    const heroSection = document.querySelector('.pelyko-home-hero');
    if (reviewSection && heroSection) heroSection.insertAdjacentElement('afterend', reviewSection);
    if (reviewSection) {
      reviewSection.innerHTML = `
        <div class="pelyko-container">
          <header class="pelyko-section-head pelyko-reviews-head" data-pelyko-reveal>
            <span class="pelyko-kicker">Avis clients PELYKO</span>
            <h2 class="pelyko-section-title">Une section pleine de retours clients.</h2>
            <p class="pelyko-lead">La mise en page est prête pour accueillir les retours liés aux premières commandes PELYKO.</p>
          </header>

          <div class="pelyko-review-disclosure">
            <strong>Aperçu avant lancement</strong>
            <span>Les témoignages affichés ci-dessous ne proviennent pas encore de commandes. Ils seront remplacés par les retours clients réellement reçus.</span>
          </div>

          <div class="pelyko-reviews-grid">
            <article class="pelyko-review-card" data-pelyko-reveal>
              <div class="pelyko-review-stars">★★★★★</div>
              <p>« Le bouton pour retirer les poils rend le nettoyage de la brosse très simple. Le geste est rapide et intuitif. »</p>
              <strong>Camille</strong>
              <span>Brosse autonettoyante PELYKO · Aperçu</span>
            </article>
            <article class="pelyko-review-card" data-pelyko-reveal>
              <div class="pelyko-review-stars">★★★★★</div>
              <p>« Pratique pour le canapé et les vêtements. Le fait de pouvoir le réutiliser est exactement ce que je cherchais. »</p>
              <strong>Thomas</strong>
              <span>Collecteur PELYKO Maison · Aperçu</span>
            </article>
            <article class="pelyko-review-card" data-pelyko-reveal>
              <div class="pelyko-review-stars">★★★★☆</div>
              <p>« Le format gant est beaucoup plus doux pour mon chat qui n’apprécie pas les brosses classiques. »</p>
              <strong>Sarah</strong>
              <span>Gant PELYKO Douceur · Aperçu</span>
            </article>
            <article class="pelyko-review-card" data-pelyko-reveal>
              <div class="pelyko-review-stars">★★★★★</div>
              <p>« Le réservoir intégré rend le bain plus simple et évite de reprendre le flacon de shampooing à chaque fois. »</p>
              <strong>Nicolas</strong>
              <span>Brosse PELYKO Mousse · Aperçu</span>
            </article>
            <article class="pelyko-review-card" data-pelyko-reveal>
              <div class="pelyko-review-stars">★★★★★</div>
              <p>« La fiche produit est claire, les photos montrent bien l’utilisation et on comprend rapidement quel produit choisir. »</p>
              <strong>Léa</strong>
              <span>Brosse autonettoyante PELYKO · Aperçu</span>
            </article>
            <article class="pelyko-review-card" data-pelyko-reveal>
              <div class="pelyko-review-stars">★★★★★</div>
              <p>« Très utile pour enlever les poils sur plusieurs textiles à la maison. L’utilisation est vraiment simple. »</p>
              <strong>Julien</strong>
              <span>Collecteur PELYKO Maison · Aperçu</span>
            </article>
          </div>

          <div class="pelyko-social-strip" data-pelyko-reveal>
            <div><strong>Paiement sécurisé</strong><span>traité dans Shopify</span></div>
            <div><strong>Produits réutilisables</strong><span>selon l’accessoire choisi</span></div>
            <div><strong>Chien & chat</strong><span>des usages du quotidien</span></div>
          </div>
        </div>`;
    }
  }

  const reveal = document.querySelectorAll('[data-pelyko-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: .12 });
    reveal.forEach((el) => observer.observe(el));
  } else reveal.forEach((el) => el.classList.add('is-visible'));
})();
